import React, {useState, useEffect, useMemo, useImperativeHandle, forwardRef} from 'react';
import { Button, Dimensions, FlatList, Pressable, ScrollView, StyleSheet, TextInput, TouchableOpacity, View } from 'react-native'

import tw from '../../../../../styles/tailwind';
import Text from '../../../../../components/Text';
import Icon from '../../../../../components/IcomoonIcon';
import Modal from '../../../../../components/Modal';
import BottomSheet from '../../../../../components/BottomSheet';
import { useForm } from 'react-hook-form';
import Input from '../../../../../components/Forms/Input';
import Select from '../../../../../components/Forms/Select';
import IconButton from '../../../../../components/IconButton';




import api from '../../../../../utils/api';
import { useQuery } from '@tanstack/react-query';
import useUnitsSearch from '../../../../../hooks/useUnitsSearch';
import useFormSubmit from '../../../../../hooks/useFormSubmit';
import SearchInput from '../../../../../components/SearchInput';

import { Ionicons } from '@expo/vector-icons';
import FutureFeeSelector from './FutureFeeSelector';

//! TODO: Mover a components
export const UnitAutocomplete = forwardRef(function UnitAutocomplete(
  // inputStyle: clases extra para el campo de búsqueda (ej. rounded-lg en caseta); sin él, píldora.
  { communityId, onUnitSelected, initialUnitId = null, openHeight = 60, nestedScrollEnabled = false, inputStyle = '' } : { communityId: number, onUnitSelected?: (unit: Unit|null) => void, initialUnitId?: string|null, openHeight?: number, nestedScrollEnabled?: boolean, inputStyle?: string }
  , ref
) {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedUnit, setSelectedUnit] = useState<Unit|null>(null);
  const [showStreetSelector, setShowStreetSelector] = useState(false);
  const isRectInput = inputStyle.includes('rounded-lg');

  const { units, filteredUnits, groupedStreetNames } = useUnitsSearch({ communityId, searchQuery })

  useImperativeHandle(ref, () => ({
    reset() {
      clearSelectedUnit()
    },
    // Selecciona la vivienda por uuid (match unico, ej. dictado por voz)
    selectByUuid(uuid: string) {
      const unit = units?.find((e: Unit) => e.uuid == uuid)
      if (unit) selectUnit(unit)
    },
    // Pre-carga la busqueda (match parcial: solo se detecto la calle)
    setQuery(value: string) {
      clearSelectedUnit()
      setShowStreetSelector(false)
      setSearchQuery(value)
    },
  }));

  
  function selectUnit(unit : Unit){
    setSelectedUnit(unit)
    setSearchQuery("")
    onUnitSelected?.(unit)
  }

  function clearSelectedUnit(){
    setSelectedUnit(null)
    onUnitSelected?.(null)
  }

  useEffect(() => {
    if(initialUnitId && filteredUnits){
      const initialUnit = filteredUnits.find(e => e.uuid == initialUnitId)

      if(initialUnit) selectUnit(initialUnit)
    }
  }, [filteredUnits, initialUnitId]);


  function onSearchQueryChanged(value){
    setSearchQuery(value)
    setShowStreetSelector(false)
  }
  
  return (
    <View style={tw`z-10`}>
      {/*  h-60 */}
      <View style={tw``}>
        <SearchInput
          onChange={onSearchQueryChanged}
          style={{ input: `bg-gray-100 h-11 text-secondary ${selectedUnit ? 'font-bold' : ''} ${inputStyle}`, container: `` }}
          placeholder='Buscar vivienda'
          value={selectedUnit ? selectedUnit.name : ''}
          disabled={!! selectedUnit}
        />

        {/* Icono borrar query o chevron selector calle */}
        {
          selectedUnit ?
            <TouchableOpacity style={tw`absolute right-3 top-0 bottom-0 justify-center`} onPress={clearSelectedUnit}>
              <View style={tw`bg-red rounded-full w-4 h-4 items-center justify-center`}>
                <Icon name="cancel" size={8} color={tw.color('white')} />
              </View>
            </TouchableOpacity>
          :
            <TouchableOpacity
              // Sigue la forma del campo: píldora por defecto; con inputStyle rectangular
              // (caseta) esquina rounded-lg y 1px adentro para no tapar el borde del campo.
              style={tw.style(
                `absolute px-3 py-3 bg-gray-300/60`,
                isRectInput ? `rounded-r-lg` : `right-0 rounded-r-full top-0 bottom-0`,
                isRectInput && { right: 1, top: 1, bottom: 1 },
              )}
              onPress={() => {
                setShowStreetSelector(searchQuery ? false : !showStreetSelector)
                setSearchQuery("")
              }}
            >
              <Ionicons
                name={`chevron-${(showStreetSelector || searchQuery) ? 'up' : 'down'}`}
                size={20}
                color={tw.color('secondary')}
              />
            </TouchableOpacity>
        }
      </View>

      {
        searchQuery &&
          <View 
            style={tw.style(
              `border border-gray-300 bg-white rounded left-0 right-0 h-${openHeight}`,
              filteredUnits?.length === 0 && `h-12`,
              false && `absolute top-11 `
            )}
          >
            <FlatList
              keyboardDismissMode='none'
              keyboardShouldPersistTaps="handled"
              data={filteredUnits}
              nestedScrollEnabled={nestedScrollEnabled}
              renderItem={({item:unit}) => 
                <TouchableOpacity
                  style={tw`px-3 border-b border-gray-200 py-2`}
                  key={unit.uuid}
                  onPress={(ev) => selectUnit(unit)}
                >
                  <View style={tw``}>
                    <Text style={tw`text-secondary`}>{unit.name}</Text>

                    {
                      unit.owners?.length > 0 &&
                      <Text style={tw`text-gray-400`}>{unit.owners[0].name}</Text>
                    }
                  </View>
                </TouchableOpacity>
              }
              ListEmptyComponent={
                <View style={tw``}>
                  <Text style={tw`py-3 text-gray-400 px-8`}>Sin resultados</Text>
                </View>
              }
            />
          </View>
      }

      {
        showStreetSelector &&
          <View style={tw.style(`h-${openHeight} z-10 w-full overflow-hidden`, false && `absolute top-11 `)}>
            <FlatList
              style={tw`flex-1 border border-gray-300 bg-white rounded-xl mt-2 left-0 right-0 z-10`}
              contentContainerStyle={tw``}
              nestedScrollEnabled={nestedScrollEnabled}
              // keyboardDismissMode='none'
              data={groupedStreetNames}
              renderItem={({ item: streetName }) =>
                <TouchableOpacity
                  style={tw`px-3 border-b border-gray-200 py-2`}
                  key={streetName}
                  onPress={(ev) => {
                    setShowStreetSelector(false)
                    setSearchQuery(streetName)
                  }}
                >
                  <View style={tw``}>
                    <Text style={tw`text-secondary`}>{streetName}</Text>
                  </View>
                </TouchableOpacity>
              }
            />
          </View>
            
            // {
            //   groupedStreetNames?.length === 0 &&
            //     <Text style={tw`py-2 text-gray-400 px-8`}>Sin resultados</Text>
            // }
      }
    </View>
  )
});



// {"member_id":"3","memberIncomeCatId":"1","cadSeleccionados":"A~7~0~500.00~1~20240301~Mantenimiento lote|M~0~0~300.00~1~20240401~Mantenimiento|M~0~0~300.00~1~20240501~Mantenimiento|M~0~0~300.00~1~20240601~Mantenimiento|","ultimoSeleccionado":"M~0~0~300.00~1~20240401~Mantenimiento","aCuentaUltimoSeleccionado":"300","cant":"1400","paymentMtd":"-1","date":"20-12-2023","serieId":"1","comprobId":"","referencia":"","funct":"savePagoMultiple"}
// [{"amount": 500, "community_id": 1, "created_at": null, "deleted_at": null, "fee": {"amount": 0, "community_id": 1, "created_at": null, "deleted_at": null, "description": null, "due_date": null, "id": 1, "name": "Cuota Junio 2023", "type": "periodic", "type_str": "Cuota periódica", "updated_at": null, "uuid": "asdfasdmc"}, "fee_id": 1, "id": 1, "is_paid": true, "paid": 500, "pending": 0, "unit": {"created_at": null, "deleted_at": null, "external_number": "", "internal_number": "", "name": "Casa 1", "settings": null, "street_name": null, "street_name_2": null, "updated_at": null, "uuid": "casa1"}, "unit_id": 1, "updated_at": "2023-07-02T09:26:30.000000Z", "uuid": "casa1-pago1"}, {"amount": 250, "community_id": 1, "created_at": "2023-07-06T06:40:47.000000Z", "deleted_at": null, "fee": {"amount": 250, "community_id": 1, "created_at": "2023-07-06T06:40:47.000000Z", "deleted_at": null, "description": null, "due_date": null, "id": 4, "name": "Cuota a 2 casas", "type": "extra", "type_str": "Cuota extraordinaria", "updated_at": "2023-07-06T06:40:47.000000Z", "uuid": "beceb629-4d29-4948-ba70-080000ce35e8"}, "fee_id": 4, "id": 7, "is_paid": false, "paid": 0, "pending": 250, "unit": {"created_at": null, "deleted_at": null, "external_number": "", "internal_number": "", "name": "Casa 1", "settings": null, "street_name": null, "street_name_2": null, "updated_at": null, "uuid": "casa1"}, "unit_id": 1, "updated_at": "2023-07-06T06:40:47.000000Z", "uuid": "df49203a-1dac-4583-8e0c-702a57f4ce48"}, {"amount": 500, "community_id": 1, "created_at": "2023-07-11T08:20:36.000000Z", "deleted_at": null, "fee": {"amount": 500, "community_id": 1, "created_at": "2023-07-03T09:53:24.000000Z", "deleted_at": null, "description": null, "due_date": null, "id": 3, "name": "Reparación de reja principal", "type": "extra", "type_str": "Cuota extraordinaria", "updated_at": "2023-07-11T08:13:59.000000Z", "uuid": "6c7921e5-4557-4686-8083-58864761e650"}, "fee_id": 3, "id": 10, "is_paid": false, "paid": 0, "pending": 500, "unit": {"created_at": null, "deleted_at": null, "external_number": "", "internal_number": "", "name": "Casa 1", "settings": null, "street_name": null, "street_name_2": null, "updated_at": null, "uuid": "casa1"}, "unit_id": 1, "updated_at": "2023-07-11T08:20:36.000000Z", "uuid": "2123f320-e328-42a4-a609-6a1f642db80f"}, {"amount": 125, "community_id": 1, "created_at": "2023-07-11T10:00:45.000000Z", "deleted_at": null, "fee": {"amount": 125, "community_id": 1, "created_at": "2023-07-11T10:00:45.000000Z", "deleted_at": null, "description": null, "due_date": null, "id": 5, "name": "Prueba", "type": "extra", "type_str": "Cuota extraordinaria", "updated_at": "2023-07-11T10:00:45.000000Z", "uuid": "ed204089-85e3-447a-9d90-e8501af8ac66"}, "fee_id": 5, "id": 18, "is_paid": false, "paid": 0, "pending": 125, "unit": {"created_at": null, "deleted_at": null, "external_number": "", "internal_number": "", "name": "Casa 1", "settings": null, "street_name": null, "street_name_2": null, "updated_at": null, "uuid": "casa1"}, "unit_id": 1, "updated_at": "2023-07-11T10:00:45.000000Z", "uuid": "33573735-d6a2-4689-ae2f-34ec68546654"}, {"amount": 500, "community_id": 1, "created_at": "2023-11-07T10:03:39.000000Z", "deleted_at": null, "fee": {"amount": 0, "community_id": 1, "created_at": "2023-11-07T10:03:39.000000Z", "deleted_at": null, "description": null, "due_date": null, "id": 6, "name": "Huuj", "type": "periodic", "type_str": "Cuota periódica", "updated_at": "2023-11-07T10:03:39.000000Z", "uuid": "e4edd5db-bd8d-400b-a0cd-1826b431d4ed"}, "fee_id": 6, "id": 21, "is_paid": false, "paid": 0, "pending": 500, "unit": {"created_at": null, "deleted_at": null, "external_number": "", "internal_number": "", "name": "Casa 1", "settings": null, "street_name": null, "street_name_2": null, "updated_at": null, "uuid": "casa1"}, "unit_id": 1, "updated_at": "2023-11-07T10:03:39.000000Z", "uuid": "56bbc5f5-1ec0-4cda-b937-624afeb9ee5d"}, {"amount": 500, "community_id": 1, "created_at": "2023-11-07T10:06:30.000000Z", "deleted_at": null, "fee": {"amount": 0, "community_id": 1, "created_at": "2023-11-07T10:06:30.000000Z", "deleted_at": null, "description": null, "due_date": null, "id": 7, "name": "Periódica a dos casas", "type": "main", "type_str": "Cuota principal", "updated_at": "2023-11-07T10:06:30.000000Z", "uuid": "4d577edd-8819-4179-bbda-7990051cbb03"}, "fee_id": 7, "id": 25, "is_paid": false, "paid": 0, "pending": 500, "unit": {"created_at": null, "deleted_at": null, "external_number": "", "internal_number": "", "name": "Casa 1", "settings": null, "street_name": null, "street_name_2": null, "updated_at": null, "uuid": "casa1"}, "unit_id": 1, "updated_at": "2023-11-07T10:06:30.000000Z", "uuid": "9dc674c5-600a-4402-ab87-e5711a104f2d"}, {"amount": 125, "community_id": 1, "created_at": "2023-11-07T10:06:54.000000Z", "deleted_at": null, "fee": {"amount": 125, "community_id": 1, "created_at": "2023-11-07T10:06:54.000000Z", "deleted_at": null, "description": null, "due_date": null, "id": 8, "name": "Extra a todas", "type": "extra", "type_str": "Cuota extraordinaria", "updated_at": "2023-11-07T10:06:54.000000Z", "uuid": "02ffa803-af18-4f39-80d5-ac327298e00e"}, "fee_id": 8, "id": 27, "is_paid": false, "paid": 0, "pending": 125, "unit": {"created_at": null, "deleted_at": null, "external_number": "", "internal_number": "", "name": "Casa 1", "settings": null, "street_name": null, "street_name_2": null, "updated_at": null, "uuid": "casa1"}, "unit_id": 1, "updated_at": "2023-11-07T10:06:54.000000Z", "uuid": "9ea672b9-99a2-4da0-b9bc-a5c9213613ac"}, {"amount": 120, "community_id": 1, "created_at": "2023-11-07T10:26:49.000000Z", "deleted_at": null, "fee": {"amount": 120, "community_id": 1, "created_at": "2023-11-07T10:26:49.000000Z", "deleted_at": null, "description": null, "due_date": null, "id": 9, "name": "Extra pa 2", "type": "extra", "type_str": "Cuota extraordinaria", "updated_at": "2023-11-07T10:26:49.000000Z", "uuid": "b66805b1-e4f8-42ba-b663-35ec66e92893"}, "fee_id": 9, "id": 595, "is_paid": false, "paid": 0, "pending": 120, "unit": {"created_at": null, "deleted_at": null, "external_number": "", "internal_number": "", "name": "Casa 1", "settings": null, "street_name": null, "street_name_2": null, "updated_at": null, "uuid": "casa1"}, "unit_id": 1, "updated_at": "2023-11-07T10:26:49.000000Z", "uuid": "7a6e2341-08ec-4eb2-9559-13952ac7589f"}]
// https://laspalomas2.residentia.net/admin.php

function UnitFeeSelector({unitFees, mainColor='secondary', onChange}){
  const [selectedUnitFees, setSelectedUnitFees] = useState([]);

  function onPress(unitFee){
    const unitFeeIndex = selectedUnitFees.findIndex(e=> e.uuid === unitFee.uuid)

    let newUnitFees
    if(unitFeeIndex === -1){
      newUnitFees = [...selectedUnitFees, unitFee]
    }else{
      newUnitFees = selectedUnitFees.filter(e => e.uuid !== unitFee.uuid)
    }

    setSelectedUnitFees(newUnitFees)
    onChange(newUnitFees)
  }


  return (
    <View style={tw``}>
      <View style={tw`gap-y-3`}>
        {
          unitFees === undefined &&
            <Text style={tw`py-18 font-xl text-gray-400 text-center`}>Cargando...</Text>
        }

        {
          unitFees?.map(unitFee => {
            const isSelected = !! selectedUnitFees.find(e => e.uuid === unitFee.uuid)

            return (
              <TouchableOpacity
                style={tw.style(`row bg-gray-100 rounded-xl px-4 py-2`, isSelected && `border border-${mainColor}`)}
                key={unitFee.uuid}
                onPress={() => onPress(unitFee)}
              >
                <View style={tw`flex-1`}>
                  <Text style={tw`text-${mainColor} font-600`}>{unitFee.fee.name}</Text>

                  <View style={tw`row`}>
                    <Text style={tw`text-red font-600`}>${unitFee.pending}</Text>
                    {
                      (unitFee.paid > 0) &&
                        <Text style={tw`text-gray-400 ml-2`}>(Abonados: ${unitFee.paid})</Text>
                    }
                  </View>
                  {/* <Text>{JSON.stringify(fee)}</Text> */}
                </View>

                <View style={tw`h-5 w-5 rounded border border-gray-400 items-center justify-center`}>
                  {
                    isSelected &&
                    <View style={tw`h-3.5 w-3.5 rounded bg-${mainColor}`}></View>
                  }
                </View>
              </TouchableOpacity> 
            )
          })
        }
      </View>
    </View>
  )
}


interface DiscountSelectorProps {
  subtotal: number;
  onDiscountChange: (discountAmount: number, discountType: 'percentage' | 'fixed', originalValue: string) => void;
}

function DiscountSelector({ subtotal, onDiscountChange }: DiscountSelectorProps) {
  const [showDiscount, setShowDiscount] = useState(false);
  const [discountValue, setDiscountValue] = useState('');
  const [discountType, setDiscountType] = useState<'percentage' | 'fixed'>('percentage');

  const discountAmount = useMemo(() => {
    if(!discountValue || parseFloat(discountValue) <= 0) return 0;

    const value = parseFloat(discountValue);
    return discountType === 'percentage'
      ? subtotal * (value / 100)
      : value;
  }, [discountValue, discountType, subtotal]);

  useEffect(() => {
    onDiscountChange(discountAmount, discountType, discountValue);
  }, [discountAmount, discountType, discountValue]);

  return (
    <>
      {/* Botón + Descuento */}
      {!showDiscount && (
        <View style={tw`row justify-center mt-3`}>
          <TouchableOpacity
            style={tw`items-center justify-center`}
            onPress={() => setShowDiscount(true)}
          >
            <View style={tw`bg-green-100 rounded-full px-4 py-2`}>
              <Text style={tw`text-green-600 font-600 text-sm`}>+ Descuento</Text>
            </View>
          </TouchableOpacity>
        </View>
      )}

      {/* Panel de descuento expandido */}
      {showDiscount && (
        <View style={tw`px-5 py-4 bg-green-50 border-b border-gray-100 mt-3`}>
          <View style={tw`row items-center justify-between mb-3`}>
            <Text style={tw`text-gray-600 font-600`}>Aplicar descuento</Text>
            <TouchableOpacity onPress={() => {
              setShowDiscount(false);
              setDiscountValue('');
            }}>
              <Text style={tw`text-gray-400 text-xl`}>✕</Text>
            </TouchableOpacity>
          </View>

          <View style={tw`row items-center gap-3`}>
            {/* Switch Tab para % / $ */}
            <View style={tw`flex-row bg-white rounded-full p-1`}>
              <TouchableOpacity
                style={tw.style(
                  `px-4 py-2 rounded-full`,
                  discountType === 'percentage' && `bg-green-500`
                )}
                onPress={() => setDiscountType('percentage')}
              >
                <Text style={tw.style(
                  `font-600`,
                  discountType === 'percentage' ? `text-white` : `text-gray-600`
                )}>%</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={tw.style(
                  `px-4 py-2 rounded-full`,
                  discountType === 'fixed' && `bg-green-500`
                )}
                onPress={() => setDiscountType('fixed')}
              >
                <Text style={tw.style(
                  `font-600`,
                  discountType === 'fixed' ? `text-white` : `text-gray-600`
                )}>$</Text>
              </TouchableOpacity>
            </View>

            {/* Input de descuento */}
            <View style={tw`flex-1`}>
              <TextInput
                value={discountValue}
                onChangeText={setDiscountValue}
                placeholder={discountType === 'percentage' ? 'ej: 10' : 'ej: 500'}
                keyboardType="numeric"
                style={tw`bg-white rounded-full px-4 py-2 text-lg`}
              />
            </View>
          </View>

          {/* Mostrar descuento calculado */}
          {discountAmount > 0 && (
            <View style={tw`mt-3 pt-3 border-t border-green-200`}>
              <View style={tw`row justify-between`}>
                <Text style={tw`text-gray-600`}>Descuento:</Text>
                <Text style={tw`text-green-600 font-600`}>-${discountAmount.toFixed(2)}</Text>
              </View>
              {/* <View style={tw`row justify-between mt-1`}>
                <Text style={tw`text-gray-800 font-700`}>Total con descuento:</Text>
                <Text style={tw`text-primary font-700 text-lg`}>${(subtotal - discountAmount).toFixed(2)}</Text>
              </View> */}
            </View>
          )}
        </View>
      )}
    </>
  );
}


export function PaymentMethodSelector({ control, name, communityId }){
  const { isLoading, error, data: paymentMethods } = useQuery({
    queryKey: ['community.payment-methods', communityId],
    queryFn: () => api.get(`/communities/${communityId}/payment-methods`).then(response => response.data),
  })


  const options = useMemo(() => {
    const defaultValue = {value: "", label: "Sin definir"}

    const options = paymentMethods?.map(method => {
      return { value: method.uuid, label: method.name}
    })

    return options ? [...options] : []
  }, [paymentMethods])

  return (
    <Select
      control={control}
      name={name}
      placeholder={{ value: "", label: "Sin definir" }}
      items={options}
      rules={{  }}
      style={{ wrapper: `mb-0`, input: tw`bg-gray-100`}}
    />
  )
}


function UnitRegisterMultiplePaymentModal({ unit, onPaymentCreated, communityId, onRequestClose, visible }){
  const [selectedUnitFees, setSelectedUnitFees] = useState([]);
  const [selectedFutureFees, setSelectedFutureFees] = useState([]);
  const [discountAmount, setDiscountAmount] = useState(0);
  const [discountType, setDiscountType] = useState<'percentage' | 'fixed'>('percentage');
  const [discountValue, setDiscountValue] = useState('');
  const { control, reset, handleSubmit, setValue, watch } = useForm();
  const amount = watch('amount')
  const [errorMessage, setErrorMessage] = useState();

  const { isLoading, error, data: unitFees } = useQuery({
    queryKey: ['unit.pending-fees', communityId, unit?.uuid],
    queryFn: () => api.get(`/communities/${communityId}/units/${unit?.uuid}/fees?pending=1`).then(response => response.data),
  })

  const { submitForm, isSubmitting } = useFormSubmit({
    onSuccess: onPaymentCreated,
    onError: (error) => {
      if(error?.message){
        setErrorMessage(error?.message)
      }
    },
    successToastMessage: "Pago registrado",
    endpoint: `/communities/${communityId}/fees/payment`,
  })

  useEffect(() => {
    reset()
    setValue("unit_id", unit.uuid)
  }, []);

  function handleDiscountChange(amount: number, type: 'percentage' | 'fixed', value: string) {
    setDiscountAmount(amount);
    setDiscountType(type);
    setDiscountValue(value);
  }

  const subtotal = useMemo(() => {
    // Sumar adeudos pendientes (tienen pending)
    const pendingTotal = selectedUnitFees.reduce((a, b) => a + b.pending, 0);

    // Sumar fees futuros (calcular amount según tipo)
    const futureTotal = selectedFutureFees.reduce((sum, fee) => {
      const amount = (fee.type?.type === "main" && unit.fee_type)
        ? unit.fee_type.amount
        : fee.amount;
      return sum + amount;
    }, 0);

    return pendingTotal + futureTotal;
  }, [selectedUnitFees, selectedFutureFees, unit]);

  const totalToPay = useMemo(() => {
    return subtotal - discountAmount;
  }, [subtotal, discountAmount])


  useEffect(() => {
    setValue("amount", `${totalToPay}`)
  }, [totalToPay]);


  const _submitForm = (data) => {
    // Los selectedUnitFees son fees pendientes (ya existen como FeeUnits)
    if(selectedUnitFees.length > 0){
      data.unit_fee_ids = selectedUnitFees.map(e => e.uuid);
    }

    // Los selectedFutureFees son fees futuros (crearán FeeUnits en backend)
    if(selectedFutureFees.length > 0){
      data.fee_ids = selectedFutureFees.map(e => e.uuid);
    }

    // Agregar descuento si existe
    if(discountAmount > 0){
      data.discount = parseFloat(discountValue); // Valor original ingresado
      data.discount_type = discountType; // 'percentage' o 'fixed'
    }

    submitForm(data)
  }


  const canSubmit = ((selectedUnitFees.length > 0 || selectedFutureFees.length > 0) && amount) //! <= totalToPay

  const windowHeight = Dimensions.get('window').height;


  return (
    <BottomSheet onRequestClose={onRequestClose} visible={visible} height={windowHeight}>
      <View style={tw`flex-1 flex pt-6 pb-0 px-5 justify-between`}>
        <View style={tw`flex-1`}>
          {/* Info vivienda */}
          <View style={tw`mb-4 px-3`}>
            <Text style={tw`text-lg font-600 text-secondary`}>{unit.name}</Text>

            {
              (unit.owners?.length > 0) &&
                <Text style={tw`font-600 text-gray-500`}>{unit.owners[0].name}</Text>
            }

            <TouchableOpacity
              style={tw`absolute -top-0 right-2 items-center justify-center`}
              onPress={onRequestClose}
            >
              <Icon name='close' style={tw`text-red`} size={26} />
            </TouchableOpacity>
          </View>
          

          {/* 
            Lista de adeudos
          */}
          <View style={tw`flex-1`}>
            <Text style={tw`text-gray-500`}>Adeudos a pagar</Text>

            <ScrollView>
              <UnitFeeSelector unitFees={unitFees} onChange={setSelectedUnitFees} />

              <FutureFeeSelector
                communityId={communityId}
                unit={unit}
                onFeesSelected={setSelectedFutureFees}
              />
            </ScrollView>
          </View>
        </View>


        {/* Parte inferior */}
        <View style={tw``}>

          {/* $___ / $900 */}
          <View style={tw``}>

            <View style={tw`row justify-center py-6 items-start border-t border-b border-gray-100`}>
              <Text style={tw`text-8 font-600 mt-1`}>$</Text>

              <View style={tw`items-center`}>
                <Input
                  control={control}
                  name='amount'
                  placeholder=''
                  style={{
                    input: `w-30 bg-gray-100 rounded-full px-3 py-1 text-right text-8 text-primary`,
                    subcontainer: ` bg-transparent rounded-0`,
                    container: tw`mb-0`,
                  }}
                  keyboardType="numeric"
                  rules={{ required: true }}
                />

                <Text style={tw`text-gray-300 text-xs mt-1`}>Monto a pagar</Text>
              </View>


              <Text style={tw`mx-3 text-8 font-600 mt-1`}>/</Text>

              <View style={tw`items-center`}>
                {discountAmount > 0 ? (
                  <>
                    <Text style={tw`text-6 font-600 mt-1 text-gray-400 line-through`}>${subtotal.toFixed(2)}</Text>
                    <Text style={tw`text-8 font-600 text-green-600`}>${totalToPay.toFixed(2)}</Text>
                  </>
                ) : (
                  <Text style={tw`text-8 font-600 mt-1`}>${subtotal.toFixed(2)}</Text>
                )}

                <Text style={tw`text-gray-300 text-xs -mt-1.5`}>Total seleccionado</Text>
              </View>
            </View>

            <DiscountSelector
              subtotal={subtotal}
              onDiscountChange={handleDiscountChange}
            />
          </View>


          {/*
            Forma de pago
          */}
          <View style={tw`mb-2 py-6 row justify-between`}>
            <Text style={tw`text-gray-500`}>Forma de Pago</Text>

            <View style={tw`w-40`}>
              <PaymentMethodSelector control={control} name={"payment_method_id"} communityId={communityId} />
            </View>
          </View>


          <View style={tw`mb-2 pb-6 row justify-between`}>
            <Text style={tw`text-gray-500`}>Folio (opcional)</Text>

            <View style={tw`w-40`}>
              <Input
                control={control}
                name='folio'
                placeholder=''
                style={{
                  input: `w-full bg-gray-100 rounded-full px-3 py-1 text-primary`,
                  subcontainer: ` bg-transparent rounded-0`,
                  container: tw`mb-0`,
                }}
                // keyboardType="numeric"
                // rules={{ required: true }}
              />
            </View>
          </View>


          {
            errorMessage &&
              <Text style={tw`text-red text-center pb-6`}>{errorMessage}</Text>
          }



          <View style={tw` -mx-5`}>
            <IconButton
              title={isSubmitting ? "Registrando pago..." : "Registrar pago"}
              disabled={!canSubmit || isSubmitting}
              style={tw.style(`w-full rounded-b-0 rounded-t-3xl py-3`, (!canSubmit || isSubmitting) && `bg-gray-700`)}
              onPress={handleSubmit(_submitForm)}
            />
          </View>
        </View>
      </View>
    </BottomSheet>
  )
}




export default function AddPaymentModal({ onRequestClose, visible, communityId, onPaymentCreated, unitId=null }) {
  const [selectedUnit, setSelectedUnit] = useState();


  function onUnitSelected(unit) {
    setSelectedUnit(unit)
  }

  function _onPaymentCreated(payment){
    console.log("_onPaymentCreated", payment);
    onPaymentCreated?.()
  }

  useEffect(() => {
    setSelectedUnit()
  }, [visible]);

  return (
    <BottomSheet onRequestClose={onRequestClose} visible={visible} height={400}>
      <View style={tw`pt-5 px-5 `}>
        {/* Header */}
        <View style={tw``}>
          <Text style={tw`mb-4 text-lg font-600 text-secondary h-7`}>Registrar pago</Text>

          <TouchableOpacity
            style={tw`absolute -top-0 right-2 items-center justify-center`}
            onPress={onRequestClose}
          >
            <Icon name='close' style={tw`text-red`} size={26} />
          </TouchableOpacity>
        </View>



        <View style={tw``}>
          {/* Vivienda */}
          <View style={tw`mb-4 z-20`}>
            <Text style={tw`text-gray-500`}>Vivienda</Text>

            <UnitAutocomplete
              communityId={communityId}
              onUnitSelected={onUnitSelected}
              initialUnitId={unitId}
            />
          </View>
        </View>

        {
          selectedUnit &&
            <UnitRegisterMultiplePaymentModal
              communityId={communityId}
              unit={selectedUnit}
              onPaymentCreated={_onPaymentCreated}
              visible={true}
              onRequestClose={onRequestClose}
            />
        }

      </View>
    </BottomSheet>
  );
}
